import { NodeEntity } from "../../features/search/services/entities/nodeEntity";

export const handleBuildTree = (data: NodeEntity[]): NodeEntity[] => {
  const nodeMap = new Map<number, NodeEntity>();
  const tree: NodeEntity[] = [];

  data.forEach((node) => {
    node.childNodes = [];
    nodeMap.set(node.id, node);
  });

  nodeMap.forEach((node) => {
    const parent = nodeMap.get(node.parentNodeId);
    if (parent) {
      parent.childNodes?.push(node);
    } else {
      tree.push(node);
    }
  });

  return tree;
};
